<template>
    <div
        class="flex items-center justify-center gap-2 lg:cz-hidden"
        @click="setShouldShowViewAll(true)"
    >
        <div class="font-semibold">{{ $t('VIEW_ALL') }}</div>
        <img
            src="../../assets/images/icons/list.svg"
            width="18"
            height="18"
            alt="X"
        >
    </div>
    <view-all-list />
</template>

<script>
    import allStores from '../../stores/all';
    import ViewAllList from '../ViewAllList.vue';

    export default {
        mixins: [allStores],

        components: {
            ViewAllList,
        },

        computed: {
            shouldShowViewAll() {
                return this.appStore.shouldShowViewAll;
            },
        },

        methods: {
            handleOverlayClose() {
                this.showOverlay = false;
            },

            setShouldShowViewAll(value) {
                this.appStore.setShouldShowViewAll(value);
            },
        },
    };
</script>
